export default __webpack_public_path__ + "static/media/anna-avatar.ab26d77b.svg";